import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientEmployeeContactComponent } from './client-employee-contact.component';

const routes: Routes = [ { path: '', component: ClientEmployeeContactComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientEmployeeContactRoutingModule { }
